import React, { useEffect, useState } from 'react';
import Assignation from './Assignation';
import Affectation from './Affectation';
import BasicData from './BasicData';
import Description from './Description';
import Attachment from './Attachment';
import { set, useForm } from 'react-hook-form';
import AffectationRelated from './AffectationRelated';
import {
  getTicketTitles, getCompanies, getElements, getTicketPriorities,
  getTicketStatus, getAreasByCompany, getPersonsByProject,
  getTicketNotificationProfiles
} from '../../services/autocomplete.service';
import FormSection, { FormElement } from '../common/FormSection';
import MainContainer from '../common/MainContainer';
import ActionButton from '../common/ActionButton';
import AlertMessage from '../common/AlertMessage';
import { useNotification } from '../../context/NotificationContext';
import CustomFields from './CustomFields';
import { getTicketCustomFieldsForm } from '../../services/ticket.service';
import { TicketFormModel } from '../../models/ticket.model';
import Notifications from './Notifications';


interface HandleFormProps {
  action?: string
  handleChange?: (...args: any[]) => void
  handleSelection?: (...args: any[]) => void
  handleCheck?: (...args: any[]) => void
  handleCustomFieldChange?: (...args: any[]) => void
  onSubmit: (p: any) => void
  ticketForm: TicketFormModel
  setBlockScreen: (p: boolean) => void
  selectedProject: string
}

export default function HandleForm({ action, handleChange, handleSelection,
  handleCheck, handleCustomFieldChange, onSubmit, ticketForm, setBlockScreen, selectedProject }: HandleFormProps) {

  const { showNotification } = useNotification();

  const { handleSubmit } = useForm<TicketFormModel>()
  const [titlesList, setTitlesList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [prioritiesList, setPrioritiesList] = useState([]);
  const [companiesList, setCompaniesList] = useState([]);
  const [elementsList, setElementsList] = useState([]);
  const [areasList, setAreasList] = useState([]);
  const [personsList, setPersonsList] = useState([]);
  const [resetArea, setResetArea] = useState(false);
  const [notificationProfilesList, setNotificationProfilesList] = useState([]);

  const requiredFields: (keyof TicketFormModel)[] = [
    'company',
    'area',
    'element',
    'title',
    'priority',
    'status_n',
    'notification_profile'
  ]

  const initComponent = () => {
    if ((action === 'create' || action === 'edit') && selectedProject) {
      setBlockScreen(true)
      Promise.all([
        getCompanies(selectedProject),
        getElements(selectedProject),
        getTicketStatus(selectedProject),
        getTicketPriorities(selectedProject),
        getTicketTitles(selectedProject),
        getPersonsByProject(selectedProject),
        getTicketNotificationProfiles(selectedProject),
        getTicketCustomFieldsForm(selectedProject)
      ]).then(function (result) {
        setCompaniesList(result[0])
        setElementsList(result[1])
        setStatusList(result[2])
        setPrioritiesList(result[3])
        setTitlesList(result[4])
        setPersonsList(result[5])
        setNotificationProfilesList(result[6])
        if (action === 'create' && handleSelection) handleSelection('custom_fields', result[7].data)
        setBlockScreen(false)
      }).catch((error) => {
        setBlockScreen(false)
        showNotification(error.response.data, 'error')
      });
    }
  }

  useEffect(initComponent, [action])

  const getAreasCompany = () => {
    if (action === 'create') {
      if (resetArea) {
        handleSelection && handleSelection('area', '')
        setAreasList([])
      }
      setResetArea(true)
      if (ticketForm.company) {
        Promise.all([
          getAreasByCompany(ticketForm.company.id, selectedProject),
        ]).then(function (result) {
          setAreasList(result[0])
        }).catch((error) => {
          showNotification(error.response.data, 'error')
        });
      }
    }
  }

  useEffect(getAreasCompany, [ticketForm.company.id])

  const formValidator = () => {
    return requiredFields.some((key) => !ticketForm[key] ||
      Object.keys(ticketForm[key]).length === 0 ||
      (Object.keys(ticketForm[key]).includes('id') &&
        ticketForm[key]['id'].length === 0)
    )
  }

  return (
    <React.Fragment>
      <MainContainer>
        <FormSection>
          <div className='ticket-form-halfwidth'>
            <FormElement>
              <Assignation
                action={action}
                handleSelection={handleSelection}
                ticketForm={ticketForm}
                companiesList={companiesList}
                areasList={areasList}
                personsList={personsList}
              />
            </FormElement>
          </div>

          <div className='ticket-form-halfwidth'>
            <FormElement>
              <BasicData
                action={action}
                handleChange={handleChange}
                handleSelection={handleSelection}
                ticketForm={ticketForm}
                titlesList={titlesList}
                statusList={statusList}
                prioritiesList={prioritiesList}
              />
            </FormElement>
          </div>

          {(false) && (<FormElement>
            <AffectationRelated
              ticketForm={ticketForm}
            />
          </FormElement>)}

          <FormElement>
            <Affectation
              action={action}
              handleSelection={handleSelection}
              ticketForm={ticketForm}
              handleCheck={handleCheck}
              elementsList={elementsList}
            />
          </FormElement>

          <FormElement>
            <Description
              action={action}
              handleChange={handleChange}
              ticketForm={ticketForm}
            />
          </FormElement>

          <FormElement>
            <CustomFields
              action={action}
              handleChange={handleCustomFieldChange}
              ticketForm={ticketForm}
            />
          </FormElement>

          <FormElement>
            <Notifications
              action={action}
              handleSelection={handleSelection}
              notificationProfilesList={notificationProfilesList}
              ticketForm={ticketForm}
            />
          </FormElement>

          <FormElement>
            <Attachment
              action={action}
              handleSelection={handleSelection}
              ticketForm={ticketForm}
            />
          </FormElement>

          {!(action === 'view') && (

            <div className='ticket-form-confirm-section'>
              <div className='text-secondary'>
                <p>
                  (*) Campos requeridos
                </p>
              </div>

              {(formValidator()) && (
                <div>
                  <AlertMessage
                    severity='error'
                    message='Hay campos requeridos sin completar' />
                </div>
              )}

              <div>
                <ActionButton
                  text='Confirmar'
                  type='confirm'
                  onClick={handleSubmit(onSubmit)}
                  disabled={formValidator()}
                />
              </div>

            </div>
          )}

        </FormSection>
      </MainContainer>
    </React.Fragment >
  );
}
